import { render, staticRenderFns } from "./DesignDashboardUploadDialog.vue?vue&type=template&id=2971f2a7&scoped=true&"
import script from "./DesignDashboardUploadDialog.vue?vue&type=script&lang=js&"
export * from "./DesignDashboardUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./DesignDashboardUploadDialog.vue?vue&type=style&index=0&id=2971f2a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971f2a7",
  null
  
)

export default component.exports